import React from "react";
import { 
    Dialog, 
    DialogContent, 
    DialogTitle, 
    Toolbar, 
    Typography 
} from "@material-ui/core";
import { StepperLaboratorio } from './StepperLaboratorio';

export const ModalTurnoDemandaLaboratorio = (props) => {
    const { open, onCloseModal, title, fecha, horariosDemandaValidos, 
        addedPracticasAndAbonar, desdeHce = false, hce } = props;
    
    const closeModal = () => {
        onCloseModal();
    }
    
    return (
        <Dialog
            maxWidth="md"
            fullWidth
            open={open}
            onClose={closeModal}
        >
            <DialogTitle >
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <DialogContent>
                <StepperLaboratorio 
                    hce={hce}
                    fecha={fecha}
                    desdeHce={desdeHce}
                    closeModal={closeModal}
                    horariosDemandaValidos={horariosDemandaValidos} 
                    addedPracticasAndAbonar={addedPracticasAndAbonar}
                />
            </DialogContent>
        </Dialog>
    );

};
